var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseBody",
    [
      _c(
        "BaseTopBar",
        [
          _c("BaseTopBarContent", { attrs: { className: "left" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("sidebar.serialnumber")) +
                " > " +
                _vm._s(_vm.$t("sidebar.all")) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("BaseTopBarContent", { attrs: { className: "right" } }, [
            _c("div", { staticClass: "action" }, [
              _c("div", { staticClass: "dropdown item dropdown-filter" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn no-bg text-secondary dropdown-toggle filter",
                    attrs: {
                      type: "button",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false"
                    }
                  },
                  [
                    _c("i", { staticClass: "fas fa-filter" }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("message.filter")) +
                        "\n            "
                    ),
                    [
                      _vm.query.status == null
                        ? _c("span", { staticClass: "badge badge-secondary" }, [
                            _vm._v(_vm._s(_vm.$t("message.all")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.query.status == "ready"
                        ? _c("span", { staticClass: "badge badge-success" }, [
                            _vm._v(
                              _vm._s(_vm.$t("apps.inventory.message.lotready"))
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.query.status == "notready"
                        ? _c("span", { staticClass: "badge badge-warning" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("apps.inventory.message.lotnotready")
                              )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.query.status == "empty"
                        ? _c("span", { staticClass: "badge badge-light" }, [
                            _vm._v(
                              _vm._s(_vm.$t("apps.inventory.message.lotempty"))
                            )
                          ])
                        : _vm._e()
                    ],
                    _vm._v(" "),
                    _vm.query.wh_id
                      ? [
                          _c("span", { staticClass: "badge badge-secondary" }, [
                            _vm._v(
                              _vm._s(
                                _vm.getWarehouseInfo(_vm.query.wh_id)
                                  .warehouse_name
                              )
                            )
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.query.bin_id
                      ? [
                          _c("span", { staticClass: "badge badge-secondary" }, [
                            _vm._v(_vm._s(_vm.getBinName(_vm.query.bin_id)))
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dropdown-menu dropdown-menu-right" },
                  [
                    _c(
                      "form",
                      {
                        staticClass: "px-3 py-2",
                        staticStyle: { "min-width": "300px" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("apps.inventory.message.lotstatus")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("BaseDropdown", {
                              attrs: {
                                classNames: ["form-control-sm"],
                                options: _vm.statusOptions
                              },
                              on: { change: _vm.handleFilterChange },
                              model: {
                                value: _vm.query.status,
                                callback: function($$v) {
                                  _vm.$set(_vm.query, "status", $$v)
                                },
                                expression: "query.status"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", [
                              _vm._v(_vm._s(_vm.$t("message.store")))
                            ]),
                            _vm._v(" "),
                            _c("BaseDropdown", {
                              attrs: {
                                classNames: ["form-control-sm"],
                                options: _vm.whOptions
                              },
                              on: { change: _vm.handleFilterChange },
                              model: {
                                value: _vm.query.wh_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.query, "wh_id", $$v)
                                },
                                expression: "query.wh_id"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group mb-0" },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(_vm.$t("apps.inventory.message.bin"))
                              )
                            ]),
                            _vm._v(" "),
                            _c("BaseDropdown", {
                              attrs: {
                                classNames: ["form-control-sm"],
                                options: _vm.binOptions,
                                disabled: !_vm.query.wh_id
                              },
                              on: { change: _vm.handleFilterChange },
                              model: {
                                value: _vm.query.bin_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.query, "bin_id", $$v)
                                },
                                expression: "query.bin_id"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BaseContent",
        { attrs: { loading: _vm.loading } },
        [
          _c(
            "div",
            { staticClass: "row", staticStyle: { "margin-bottom": "12px" } },
            [
              _c("div", { staticClass: "col-lg-4 ml-auto" }, [
                _c(
                  "label",
                  { staticClass: "d-flex d-flex align-items-center" },
                  [
                    _c("span", { staticClass: "mr-2" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("message.search")) +
                          ":\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("BaseInput", {
                      attrs: {
                        placeholder: _vm.$t("placeholder.searchstock"),
                        type: "text",
                        clear: ""
                      },
                      on: {
                        onEnter: _vm.handleSearchEnter,
                        onClear: _vm.handleSearchClear
                      },
                      model: {
                        value: _vm.query.q,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "q", $$v)
                        },
                        expression: "query.q"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("base-table", {
            attrs: { pagination: _vm.pagination },
            on: { onPageChange: _vm.handlePageChange },
            scopedSlots: _vm._u([
              {
                key: "thead",
                fn: function() {
                  return [
                    _c("thead", [
                      _c("tr", [
                        _c("th", { staticStyle: { "min-width": "160px" } }, [
                          _vm._v(_vm._s(_vm.$t("series.serial")))
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(
                            _vm._s(_vm.$t("apps.inventory.message.product"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("apps.inventory.message.serialnumber")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(
                            _vm._s(_vm.$t("apps.inventory.message.warehouse"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("apps.inventory.message.bin")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "th",
                          [
                            _c(
                              "base-sort-label",
                              {
                                on: {
                                  onChange: function($event) {
                                    return _vm.handleSortChange(
                                      $event,
                                      "date_in"
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.sort.date_in,
                                  callback: function($$v) {
                                    _vm.$set(_vm.sort, "date_in", $$v)
                                  },
                                  expression: "sort.date_in"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("apps.inventory.message.datein")
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          [
                            _c(
                              "base-sort-label",
                              {
                                on: {
                                  onChange: function($event) {
                                    return _vm.handleSortChange(
                                      $event,
                                      "date_product"
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.sort.date_product,
                                  callback: function($$v) {
                                    _vm.$set(_vm.sort, "date_product", $$v)
                                  },
                                  expression: "sort.date_product"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t(
                                        "apps.inventory.message.dateproduct"
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          [
                            _c(
                              "base-sort-label",
                              {
                                on: {
                                  onChange: function($event) {
                                    return _vm.handleSortChange(
                                      $event,
                                      "date_expire"
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.sort.date_expire,
                                  callback: function($$v) {
                                    _vm.$set(_vm.sort, "date_expire", $$v)
                                  },
                                  expression: "sort.date_expire"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t(
                                        "apps.inventory.message.dateexpire"
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          [
                            _c(
                              "base-sort-label",
                              {
                                on: {
                                  onChange: function($event) {
                                    return _vm.handleSortChange(
                                      $event,
                                      "unit_balance"
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.sort.unit_balance,
                                  callback: function($$v) {
                                    _vm.$set(_vm.sort, "unit_balance", $$v)
                                  },
                                  expression: "sort.unit_balance"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t(
                                        "apps.inventory.message.totalbanalce"
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          [
                            _c(
                              "base-sort-label",
                              {
                                on: {
                                  onChange: function($event) {
                                    return _vm.handleSortChange($event, "cost")
                                  }
                                },
                                model: {
                                  value: _vm.sort.cost,
                                  callback: function($$v) {
                                    _vm.$set(_vm.sort, "cost", $$v)
                                  },
                                  expression: "sort.cost"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("apps.inventory.message.cost")
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("apps.inventory.message.serialstatus")
                            )
                          )
                        ])
                      ])
                    ])
                  ]
                },
                proxy: true
              },
              {
                key: "tbody",
                fn: function() {
                  return [
                    _c(
                      "tbody",
                      [
                        _c("tr", [
                          _vm.empty
                            ? _c(
                                "td",
                                {
                                  staticClass: "text-center",
                                  attrs: { colspan: "11" }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("message.notfounddata")) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.data, function(item, index) {
                          return _c("tr", { key: index }, [
                            _c(
                              "td",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        name: "InventorySerialEdit",
                                        query: {
                                          id: item.serId,
                                          code: item.serCode
                                        }
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.serCode) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "span",
                                { staticClass: "badge badge-secondary" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.getProductFullName(
                                          item.product.productName,
                                          item.sku.attributes
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.serialNumber) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.warehouse.warehouseName) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    item.warehouse.binLocations.reduce(function(
                                      acc,
                                      cur
                                    ) {
                                      if (cur.id === item.binLocationId) {
                                        acc = cur.code
                                      }
                                      return acc
                                    },
                                    null)
                                  ) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    item.dateIn
                                      ? _vm.getDate(item.dateIn)
                                      : null
                                  ) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    item.dateProduct
                                      ? _vm.getDate(item.dateProduct)
                                      : null
                                  ) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    item.dateExpire
                                      ? _vm.getDate(item.dateExpire)
                                      : null
                                  ) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.unitBalance) +
                                  "/" +
                                  _vm._s(item.unitInit) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.getNumber(item.cost)) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                item.unitBalance <= 0
                                  ? _c("span", { staticClass: "text-grey" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "apps.inventory.message.serialempty"
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ])
                                  : [
                                      item.isReady
                                        ? _c(
                                            "span",
                                            { staticClass: "text-success" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "apps.inventory.message.serialready"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            { staticClass: "text-warning" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "apps.inventory.message.serialnotready"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                    ]
                              ],
                              2
                            )
                          ])
                        })
                      ],
                      2
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e992d60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e992d60","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/inventory/serialnumber/List.vue
// module id = null
// module chunks = 